export default "__VITE_ASSET__00d49726__"